import { Box } from '@creditas-ui/layout';
import { styled, css } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';

const Menu = styled(Box)`
  position: fixed;
  padding: 0;
  top: 0;
  left: 0;
  height: 8vh;
  width: 100%;
  z-index: 5;
  background-color: ${selectTheme('colors.neutral.0')};
`;

const MenuBar = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding-inline: 20px;
  height: 100%;
  border-bottom: 1px solid ${selectTheme('colors.neutral.10')};
`;

const expanded = ({ isOpen = false }: { isOpen?: boolean }) =>
  isOpen &&
  css`
    height: calc(100vh - 8vh);
  `;

const MenuExpanded = styled(Box)`
  height: 0;
  background-color: ${selectTheme('colors.neutral.0')};
  transition: height 0.8s ease-out;
  position: relative;
  overflow: hidden;
  box-shadow: 0 50px 50px ${selectTheme('colors.neutral.15')};
  ${expanded};
`;

export { Menu, MenuBar, MenuExpanded };
